import React from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-tab_1-1-2_co-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  max-width: 200px;\n  transition: all 0.2s ease;\n  color: var(--gray-700);\n  font-family: var(--font-family);\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n}\n.react-tab_1-1-2_co-tab:not([data-disabled]):not([data-co-disabled])[data-co-focus], .react-tab_1-1-2_co-tab:not([data-disabled]):not([data-co-disabled]):focus, .react-tab_1-1-2_co-tab:not([data-disabled]):not([data-co-disabled])[data-co-hover], .react-tab_1-1-2_co-tab:not([data-disabled]):not([data-co-disabled]):hover {\n  color: var(--primary-600);\n}\n\n.react-tab_1-1-2_co-tab.react-tab_1-1-2_co-tab--active {\n  color: var(--primary-600);\n}\n.react-tab_1-1-2_co-tab.react-tab_1-1-2_co-tab--active::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background-color: var(--primary-600);\n}\n.react-tab_1-1-2_co-tab.react-tab_1-1-2_co-tab--small {\n  font-size: var(--font-size-small);\n}\n.react-tab_1-1-2_co-tab.react-tab_1-1-2_co-tab--medium, .react-tab_1-1-2_co-tab {\n  font-size: var(--font-size-base);\n}\n.react-tab_1-1-2_co-tab[data-co-disabled], .react-tab_1-1-2_co-tab[data-disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}";
var styles = {
  "co-tab": "react-tab_1-1-2_co-tab",
  "co-tab--active": "react-tab_1-1-2_co-tab--active",
  "co-tab--small": "react-tab_1-1-2_co-tab--small",
  "co-tab--medium": "react-tab_1-1-2_co-tab--medium"
};
styleInject(css);

const Tab = ({
  className = "",
  forwardedRef,
  active,
  children,
  disabled,
  size = "medium",
  ...props
}) => {
  const classStyles = [styles["co-tab"], styles[`co-tab--${size}`], {
    [styles["co-tab--active"]]: active
  }, className];
  return React.createElement(React.Fragment, null, disabled ? React.createElement("span", _extends({
    className: cc(classStyles),
    ref: forwardedRef,
    "data-co-disabled": disabled
  }, props, {
    "data-co-name": "Tab",
    "data-co-version": "1.1.2",
    "data-co-project": "cobalt"
  }), children) : React.createElement("a", _extends({
    className: cc(classStyles),
    ref: forwardedRef
  }, props, {
    "data-co-name": "Tab",
    "data-co-version": "1.1.2",
    "data-co-project": "cobalt"
  }), children));
};

export default Tab;
